// extracted by mini-css-extract-plugin
export default {"truncateCompanyName":"_3474dec6","iconContainer":"_ddaf6b24","hidden":"_84591e02"};